import { makeStyles, createStyles } from '@material-ui/core/styles';

const UploadVideoPopupStyles = makeStyles((theme: any) => createStyles({
  dialogPaper: {
    width: 660,
    minHeight: 365,
    height: "auto",
    display: "inline-block",
    margin: 0,
    overflowX: "hidden",
    overflowY: "auto",
  },
  popup: {
    minHeight: 365,
    height: "auto",
    width: "100%",
  },
  uploadHeader: {
    fontSize: 24,
    position: "relative",
    left: 30,
    top: 58,
    fontWeight: 400,
  },
  dropzoneText: {
    fontSize: 16,
    color: "#AAA6A6",
    position: "relative",
    top: 36,
  },
  uploadSizeHeader: {
    fontSize: "1rem",
    position: "relative",
    top: 60,
    left: 30,
    fontWeight: 400,
  },
  loadingSpinner: {
    color: "grey",
    position: "absolute",
    right: 93,
    bottom: 100,
  },
  error: {
    color: "red",
    position: "absolute",
    top: 95,
    left: 61
  },
  dimensionsError: {
    top: 5,
    color: "red",
    fontSize: 16,
  },
  fileName: {
    fontSize: 14,
    position: 'absolute',
    left: 20,
    top: 14,
  },
  fileError: {
    fontSize: 14,
    color: "red",
    left: 20,
    bottom: 12,
    position: 'absolute',
  },
})
)

export { UploadVideoPopupStyles };